import React, { useState } from "react";

import { Button, Grid, Typography } from "@mui/material";
import { RoomOutlined, SensorDoorOutlined } from "@mui/icons-material";

import { PageStandard } from "components/admin/PageStandard";
import { useUserContext } from "contexts/UserContext";
import { BlockStandard } from "components/admin/BlockStandard";
import {
  RefrigerationDetail,
  RefrigerationDetailItem,
  emptyRefrigeration,
} from "components/forms/RefrigerationDetail";
import { useSetError } from "contexts/ErrorContext";
import { CustomCodes } from "contexts/ErrorContextData";
import { createRefrigeration } from "api/automation";

export const CreateRefrigeration = ({ history }) => {
  const { currentSpace, currentEnvironment, token } = useUserContext();
  const setError = useSetError();

  const [refrigerationsData, setRefrigerationsData] = useState<
    RefrigerationDetailItem[]
  >([{ ...emptyRefrigeration }]);

  const handleSubmit = async () => {
    if (refrigerationsData?.length && currentEnvironment?.id) {
      try {
        await createRefrigeration(
          token,
          currentEnvironment.id,
          refrigerationsData
        );
        history.goBack();
      } catch (error) {
        // @ts-expect-error
        setError(error.response.data.error);
      }
    } else {
      setError(CustomCodes.INCOMPLETE_FORM);
    }
  };

  const handleAdd = () => {
    setRefrigerationsData((prevRefrigerations) => [
      ...prevRefrigerations,
      { ...emptyRefrigeration },
    ]);
  };

  const handleRefrigerationUpdate = (
    updatedRefrigeration: RefrigerationDetailItem,
    position: number
  ) => {
    if (refrigerationsData?.length) {
      const updatedRefrigerationsData = [...refrigerationsData];
      updatedRefrigerationsData.splice(position, 1, updatedRefrigeration);
      setRefrigerationsData(updatedRefrigerationsData);
    }
  };

  const handleRefrigerationDelete = (position: number) => {
    const updatedRefrigerationsData = [...refrigerationsData];
    updatedRefrigerationsData.splice(position, 1);
    setRefrigerationsData(updatedRefrigerationsData);
  };

  return (
    <PageStandard title="Refrigeração" onAdd={handleAdd}>
      <BlockStandard hideDivider>
        <Grid item container alignItems="center">
          <RoomOutlined sx={{ mr: 0.5 }} color="secondary" />
          <Typography sx={{ mr: 3 }}>{currentSpace?.schoolName}</Typography>
          <SensorDoorOutlined sx={{ mr: 0.5 }} color="secondary" />
          <Typography sx={{ mr: 3 }}>{currentEnvironment?.name}</Typography>
        </Grid>
      </BlockStandard>

      {!!refrigerationsData?.length &&
        refrigerationsData.map((item, position) => {
          return (
            <RefrigerationDetail
              key={position}
              refrigerationData={item}
              refrigerationPos={position}
              onChange={(updatedRefrigeration) => {
                handleRefrigerationUpdate(updatedRefrigeration, position);
              }}
              onDelete={() => handleRefrigerationDelete(position)}
            />
          );
        })}

      {!!refrigerationsData?.length && (
        <Button variant="contained" onClick={handleSubmit}>
          Atualizar dados de refrigerador
        </Button>
      )}
    </PageStandard>
  );
};
